import { DeviceGroup } from '@wiot/shared-domain/models/device-group/device-group';
import { SAVE_DEVICE_GROUPS } from '../constants/actionTypes';
import { DeviceGroupsActionTypes } from '../types';

export const saveDeviceGroups = (deviceGroups: DeviceGroup[] = []): DeviceGroupsActionTypes => ({
  type: SAVE_DEVICE_GROUPS,
  payload: deviceGroups,
});
